import { render, staticRenderFns } from "./choosecompany.vue?vue&type=template&id=2a63758a&scoped=true&"
import script from "./choosecompany.vue?vue&type=script&lang=js&"
export * from "./choosecompany.vue?vue&type=script&lang=js&"
import style0 from "./choosecompany.vue?vue&type=style&index=0&id=2a63758a&scoped=true&lang=css&"
import style1 from "./choosecompany.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a63758a",
  null
  
)

export default component.exports